<template>
    <article class="card card-link">
        <router-link :to="{ name: `${routerLinkName}`, params:{deviceId: deviceId}}" class="card-body">
            <div class="alert alert-danger alert-sm" v-if="assetsAwaitingParts">
                <animated-error></animated-error>
                <div class="alert-content">Some assets are awaiting parts</div>
            </div>
            <div class="media">
                <div class="media-left">
                    <img v-if="device.version_image" :src="device.version_image" class="img-2x">
                    <template v-if="!device.version_image">
                        <icon-mobile v-if="device.type === 'phone'" size="2x" class="icon-all-muted"></icon-mobile>
                        <icon-tablet v-if="device.type === 'tablet'" size="2x" class="icon-all-muted"></icon-tablet>
                    </template>
                </div>
                <div class="media-body">
                    <h5 class="mb-2">{{ device.title_with_colour }}</h5>
                    <p class="mb-0 text-muted text-sm">IMEI: <template v-if="device.imei">{{ device.imei }}</template><template v-if="!device.imei">Unavailable</template></p>
                    <p class="mb-0 mt-1 text-muted text-sm" v-if="device.board">Board: {{ device.board }}</p>
                    <p class="mb-0 mt-1 text-muted text-sm" v-if="device.so_number">SO: {{ device.so_number }}</p>
                    <ul class="list-unstyled mt-3 text-muted text-sm">
                        <li v-for="repair in deviceRepairs" :key="repair.id">
                            {{repair.title}}
                        </li>
                    </ul>
                </div>
                <div class="media-right align-self-center first-xs first-sm">
                    <div class="badge" v-if="deviceStatus" :class="{'badge-success': device.complete, 'badge-warning': !device.complete}">
                        {{ deviceStatus.title }}
                    </div>
                </div>
            </div>
        </router-link>
        <a href="#" class="card-footer text-link" @click="addNote()">
            <i class="fa fa-plus mr-2"></i> Add Note
        </a>

    </article>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {

        props:['device', 'job', 'assetsAwaitingParts'],

        mounted() {
            this.loadDeviceStatus({
                statusId: this.device.status_id
            });
            this.loadDeviceRepairs({
                jobId: this.job.id,
                deviceId: this.device.id
            });
        },

        computed: {
            ...mapGetters([
                "additionalData",
                "deviceRepairs",
                "deviceStatus"
            ]),

            deviceId() {
                return this.device.id;
            },

            routerLinkName() {
                if (this.device.current_step && this.device.current_step !== 'job') {
                    return this.device.current_step
                }

                return 'repair'
            }
        },

        methods: {
            ...mapActions([
                "setDevice",
                "loadDeviceRepairs",
                "loadDeviceStatus",
                "setNoteableId",
                "setNoteableType",
                "setAdditionalData"
            ]),

            /** Open the note modal */
            addNote() {
                this.$emit("openNoteModal");
            },
        }
    }
</script>